import {SpinButtonModule} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonModule';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {FreeRoundsScreenEvents} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents';
import {RecodeEvents} from '@fantasmagames/slot/src/integration/RecodeEvents';
import {RecodeSpinButtonBasicState} from 'src/spinbutton/states/RecodeSpinButtonBasicState';
import {RecodeSpinButtonFreeSpinState} from 'src/spinbutton/states/RecodeSpinButtonFreeSpinState';
import {RecodeSpinButtonWhileSpinningState} from 'src/spinbutton/states/RecodeSpinButtonWhileSpinningState';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';

export class RecodeSpinButtonModule extends SpinButtonModule {

	protected _canAddKeyboardInput: boolean = false;

	protected _isWaitingForFreeGames: boolean = false;

	protected _isFreeRoundScreenOn: boolean = false;

	protected _errorDialogOpen: boolean = false;

	protected _freeSpinsIntroScreenOpened: boolean = false;

	public afterInit(): void {
		super.afterInit();
		this._hasQuickstop = false;
		if ((window as any)._certificationSettings && (window as any)._certificationSettings.hasOwnProperty('hideStop')) {
			this._hasQuickstop = !(window as any)._certificationSettings.hideStop;
		}
	}

	protected setupCertificationSettings(): void {
		if ((window as any)._certificationSettings && (window as any)._certificationSettings.hasOwnProperty('spinDelay')) {
			this._spinTimeRegulation = (window as any)._certificationSettings.spinDelay;
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_HIDDEN, this.onFreeGamesScreenClosed);
		this.on(FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN, this.onFreeGamesScreenOpened);
		this.on(FreeRoundsScreenEvents.SOON_WILL_SHOW_FREE_ROUNDS_END, this.onSoonWillShowFreeRoundEndScreen);

		this.on(FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW, this.onExpectedToShowFreeRounds);
		this.on(RecodeEvents.CLOSED_ERROR_DIALOG, this.onCloseErrorDialog);
		this.on(RecodeEvents.SHOWING_ERROR, this.onShowingError);
		this.on(RecodeEvents.SERVER_AUTOPLAY_INTERRUPT, this.onServerAutoplayInterrupt);
		this.on(RecodeEvents.SERVER_GAMEPLAY_RESUME, this.onServerGameplayResume);
	}

	protected onAutoplayStopClicked(): void {
		this.eventManager.emit(SpinButtonEvents.STOP_AUTOPLAY_BUTTON_PRESSED);
		if (this.logic.freeSpinsLeft <= 0 || !this._freeSpinsIntroScreenOpened) {
			this.view.uninitAutoplay();
		}

		this._isInAutoplay = false;
	}

	protected onFreeSpinsIntroStarted(): void {
		super.onFreeSpinsIntroStarted();
		this._freeSpinsIntroScreenOpened = true;
	}

	protected onFreeSpinsIntroFinished(): void {
		super.onFreeSpinsIntroFinished();
		this._freeSpinsIntroScreenOpened = false;
	}

	protected setupStates(): void {
		super.setupStates();
		this.addState(new RecodeSpinButtonBasicState(this, SpinButtonModule.BASIC_STATE));
		this.addState(new RecodeSpinButtonFreeSpinState(this, SpinButtonModule.FREE_SPINS_STATE));
		this.addState(new RecodeSpinButtonWhileSpinningState(this, SpinButtonModule.REELS_SPINNING_STATE));
	}

	protected onCloseErrorDialog(): void {
		this._errorDialogOpen = false;
	}

	protected onShowingError(): void {
		this._errorDialogOpen = true;
	}

	protected onExpectedToShowFreeRounds(): void {
		this._isWaitingForFreeGames = true;

		this.view.disableSpinButton();
		this.canSpin = false;
	}

	protected onFreeGamesScreenClosed(): void {
		this._isFreeRoundScreenOn = false;
		this._canAddKeyboardInput = true;
		this.addKeyboardInput();

		if (this._isWaitingForFreeGames) {
			this._isWaitingForFreeGames = false;
			this.view.enableSpinButton();
			this.canSpin = true;
		}
	}

	protected onFreeGamesScreenOpened(): void {
		this._isFreeRoundScreenOn = true;
		this._canAddKeyboardInput = false;
		this.removeKeyboardInput();
	}

	protected onSoonWillShowFreeRoundEndScreen(): void {
		this._isFreeRoundScreenOn = true;
		this._canAddKeyboardInput = false;
		this.removeKeyboardInput();

		this._isWaitingForFreeGames = true;

		this.view.disableSpinButton();
		this.canSpin = false;
	}

	protected addKeyboardInput(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;

		if (!logic.hasFreeGames() || this._canAddKeyboardInput) {
			super.addKeyboardInput();
		}
	}

	protected keyboardInput(event: KeyboardEvent): void {
		// space bar functionality should be removed completely (we love you Microgaming)
		/*if (!this._isFreeRoundScreenOn && !this._errorDialogOpen) {
			super.keyboardInput(event);
		}*/
	}

	protected onServerAutoplayInterrupt(): void {
		this.disableSpaceInput();
	}

	protected onServerGameplayResume(): void {
		this.enableSpaceInput();
	}

	protected disableSpaceInput(): void {
		this._isKeyboardInputEnabled = false;
	}

	protected enableSpaceInput(): void {
		this._isKeyboardInputEnabled = true;
	}

	public get isWaitingForFreeGames(): boolean {
		return this._isWaitingForFreeGames;
	}
}



// WEBPACK FOOTER //
// ./src/spinbutton/RecodeSpinButtonModule.ts